import { Box } from '@mui/material';

import { EmptyStateMessage, Section, SectionCard, SectionHeader } from '@/components/common';
import { alwaysSeesEmptySections } from '@/auth/sectionVisibility';
import { ProjectSubsection } from './ProjectSubsection';
import type { AppraisalDetailResponse } from '@/api/types/appraisal.types';
import type { RecordAccess } from '@/auth/permissions.types';

interface ProjectHistorySectionProps {
  appraisalDetail: AppraisalDetailResponse;
  permissions: RecordAccess | undefined;
}

export function ProjectHistorySection({ appraisalDetail, permissions }: ProjectHistorySectionProps) {
  const { projectGroups } = appraisalDetail;
  const sectionAccess = permissions?.sections.projectInterviews;

  // #1069 hides empty read-only sections from the Appraisee view; #1102 keeps them
  // visible (read-only) for Mentor / TC / HR / Staffing, who must always see every section.
  if (
    projectGroups.length === 0 &&
    sectionAccess?.access !== 'edit' &&
    !alwaysSeesEmptySections(permissions?.role)
  ) {
    return null;
  }

  return (
    <Section>
      <SectionHeader>PROJECT HISTORY &amp; INTERVIEW CANDIDATES</SectionHeader>
      {projectGroups.length === 0 ? (
        <SectionCard>
          <EmptyStateMessage message="No project history available." />
        </SectionCard>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {projectGroups.map((group) => (
            <SectionCard key={group.appraisalJobEndId}>
              <ProjectSubsection
                group={group}
                sectionAccess={sectionAccess}
                appraisalId={appraisalDetail.id}
                rowVersion={appraisalDetail.rowVersion}
              />
            </SectionCard>
          ))}
        </Box>
      )}
    </Section>
  );
}

export default ProjectHistorySection;
